import React from 'react';
import RankingBase from '../components/base/ranking-base';

const TourneysComponentsFormRulesPartRanking = () => {
  return <RankingBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartRanking;
